import { FC } from 'react';
import { isArray } from 'lodash';
import { motion } from 'framer-motion';
import { XIcon } from '@heroicons/react/solid';
import { EventTrackerInput } from 'wb-reddit/graphql/generated';
import { IColumnEditor } from '@aleph/supergrid';

const UrlsColumnEditor: FC<IColumnEditor<EventTrackerInput[]>> = (params) => {
	const { value, setValue } = params;

	return (
		<div
			className="flex flex-col gap-[8px] p-[8px]"
		>
			{
				isArray(value)
				&& value.map((word, idx) => (
					<motion.div
						key={idx}
						className="flex flex-col gap-[8px]"
						initial={{ y: 100, opacity: 0 }}
						animate={{ y: 0, opacity: 1 }}
						transition={{
							bounce: 0.2, duration: 0.1, delay: 0.1,
						}}
					>
						<div className="bg-gray-700 w-full flex items-top justify-between p-[8px]
                            text-white rounded-lg text-[14px]"
						>
							<div className='overflow-auto'>
								{word?.url}
							</div>

							<div
								className="cursor-pointer"
								onClick={() => setValue(value.filter((currValue) => currValue !== word))}
							>
								<XIcon
									height={14}
									width={14}
								/>
							</div>
						</div>
					</motion.div>
				))
			}
		</div>
	);
};

export default UrlsColumnEditor;
